/* ADSCALAR — home hero slideshow + product-card wishlist. Safe to load on any page. */
(function () {
  var hero = document.querySelector('[data-asc-hero]');
  if (hero) {
    var slides = hero.querySelectorAll('.asc-hero-slide');
    var dots = hero.querySelectorAll('.asc-hero-dots button');
    var live = hero.querySelector('[data-asc-hero-live]');
    var n = slides.length, cur = 0;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function go(i) {
      cur = (i + n) % n;
      slides.forEach(function (s, k) { s.classList.toggle('on', k === cur); });
      dots.forEach(function (d, k) {
        d.classList.toggle('on', k === cur);
        d.classList.toggle('past', k < cur);
        d.setAttribute('aria-current', k === cur ? 'true' : 'false');
      });
      if (live) live.classList.toggle('show', cur === 0);
    }
    // Automatically cycle through all configured hero banners; pause for interaction.
    var rotationTimer = null;
    function stopRotation() {
      if (rotationTimer !== null) { clearInterval(rotationTimer); rotationTimer = null; }
    }
    function startRotation() {
      stopRotation();
      if (n < 2 || reduced || document.hidden || hero.matches(':hover') || hero.matches(':focus-within')) return;
      rotationTimer = setInterval(function () { go(cur + 1); }, 6000);
    }
    dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); startRotation(); }); });

    var prevBtn = hero.querySelector('[data-asc-hero-prev]');
    var nextBtn = hero.querySelector('[data-asc-hero-next]');
    if (prevBtn) prevBtn.addEventListener('click', function () { go(cur - 1); startRotation(); });
    if (nextBtn) nextBtn.addEventListener('click', function () { go(cur + 1); startRotation(); });

    // Mobile swipe only. Passive touch listeners preserve normal vertical scrolling
    // and do not intercept taps on links/buttons inside the hero.
    var touchStartX = 0, touchStartY = 0, touchActive = false;
    hero.addEventListener('touchstart', function (e) {
      if (window.innerWidth > 767 || !e.touches || e.touches.length !== 1) return;
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      touchActive = true;
      stopRotation();
    }, { passive: true });
    hero.addEventListener('touchend', function (e) {
      if (!touchActive || window.innerWidth > 767 || !e.changedTouches || e.changedTouches.length !== 1) return;
      touchActive = false;
      var dx = e.changedTouches[0].clientX - touchStartX;
      var dy = e.changedTouches[0].clientY - touchStartY;
      if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.2) go(dx < 0 ? cur + 1 : cur - 1);
      startRotation();
    }, { passive: true });
    hero.addEventListener('touchcancel', function () { touchActive = false; startRotation(); }, { passive: true });

    hero.addEventListener('mouseenter', stopRotation);
    hero.addEventListener('mouseleave', startRotation);
    hero.addEventListener('focusin', stopRotation);
    hero.addEventListener('focusout', function (e) { if (!hero.contains(e.relatedTarget)) startRotation(); });
    document.addEventListener('visibilitychange', function () { if (document.hidden) stopRotation(); else startRotation(); });
    startRotation();
    if (live) live.classList.add('show');
    if (!reduced) requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        slides.forEach(function (s) { s.classList.add('kb'); });
      });
    });
  }

  var KEY = 'ek_wishlist';
  function idOf(entry) { return typeof entry === 'string' ? entry : entry && entry.id; }
  function getWish() { try { return JSON.parse(localStorage.getItem(KEY) || '[]') || []; } catch (e) { return []; } }
  function saveWish(list) {
    localStorage.setItem(KEY, JSON.stringify(list));
    try { window.dispatchEvent(new Event('ek:wishlist-change')); } catch (e) {}
  }
  function paintCards() {
    var ids = getWish().map(idOf);
    document.querySelectorAll('[data-asc-card-wish]').forEach(function (b) {
      var on = ids.indexOf(b.getAttribute('data-pid')) > -1;
      b.classList.toggle('on', on);
      b.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-asc-card-wish]');
    if (!b) return;
    e.preventDefault();
    var pid = b.getAttribute('data-pid');
    var list = getWish(); var i = list.map(idOf).indexOf(pid);
    if (i === -1) {
      list.push({ id: pid, title: b.getAttribute('data-title') || '', url: b.getAttribute('data-url') || '', img: b.getAttribute('data-img') || '', price: b.getAttribute('data-price') || '' });
    } else { list.splice(i, 1); }
    saveWish(list);
    paintCards();
  });
  paintCards();

  var sortSel = document.querySelector('[data-asc-sort]');
  if (sortSel) sortSel.addEventListener('change', function () {
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', this.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
})();

/* Mobile collection filter sheet toggle */
(function () {
  var btn = document.querySelector('[data-asc-mfilter]');
  var sheet = document.querySelector('[data-asc-filters]');
  var scrim = document.querySelector('[data-asc-mfilter-scrim]');
  var closeBtn = document.querySelector('[data-asc-mfilter-close]');
  if (!btn || !sheet) return;
  function open() { sheet.classList.add('open'); if (scrim) scrim.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function close() { sheet.classList.remove('open'); if (scrim) scrim.classList.remove('open'); document.body.style.overflow = ''; }
  btn.addEventListener('click', open);
  if (scrim) scrim.addEventListener('click', close);
  if (closeBtn) closeBtn.addEventListener('click', close);
})();

/* Collection card inline quick-add */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-asc-card-add]');
    if (!btn || btn.disabled || btn.classList.contains('pending') || btn.classList.contains('added')) return;
    e.preventDefault(); e.stopPropagation();
    btn.classList.add('pending');
    fetch('/cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: btn.getAttribute('data-id'), quantity: 1 }) })
      .then(function (r) { return r.ok ? r.json() : Promise.reject(); })
      .then(function () {
        btn.classList.remove('pending'); btn.classList.add('added');
        if (window.ekCart && window.ekCart.refresh) window.ekCart.refresh();
        if (window.ekCart && window.ekCart.open) window.ekCart.open();
        setTimeout(function () { btn.classList.remove('added'); }, 1600);
      })
      .catch(function () { btn.classList.remove('pending'); });
  });
})();

/* Collection infinite scroll */
(function () {
  var sentinel = document.querySelector('[data-asc-infinite]');
  var grid = document.querySelector('[data-asc-grid]');
  if (!sentinel || !grid || !('IntersectionObserver' in window)) return;
  var pag = document.querySelector('[data-asc-pagination]'); if (pag) pag.style.display = 'none';
  var loading = false, nextUrl = sentinel.getAttribute('data-next-url');
  var io = new IntersectionObserver(function (entries) {
    if (entries[0].isIntersecting && !loading && nextUrl) load();
  }, { rootMargin: '700px' });
  io.observe(sentinel);
  function load() {
    loading = true;
    fetch(nextUrl).then(function (r) { return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var ng = doc.querySelector('[data-asc-grid]');
      if (ng) { while (ng.firstElementChild) grid.appendChild(ng.firstElementChild); }
      var nsent = doc.querySelector('[data-asc-infinite]');
      nextUrl = nsent ? nsent.getAttribute('data-next-url') : null;
      if (!nextUrl) { io.disconnect(); sentinel.remove(); }
      loading = false;
    }).catch(function () { loading = false; });
  }
})();

/* Hover image hydration */
(function () {
  function hydrate(card) {
    if (!card) return;
    var img = card.querySelector('.asc-card-img2[data-src]');
    if (!img) return;
    if (img.dataset.srcset) img.setAttribute('srcset', img.dataset.srcset);
    if (img.dataset.sizes) img.setAttribute('sizes', img.dataset.sizes);
    img.setAttribute('src', img.dataset.src);
    delete img.dataset.src; delete img.dataset.srcset; delete img.dataset.sizes;
  }
  function onEnter(e) {
    var card = e.target.closest ? e.target.closest('.asc-card') : null;
    if (card) hydrate(card);
  }
  document.addEventListener('pointerover', onEnter, { passive: true });
  document.addEventListener('focusin', onEnter);
})();

/* Collection grid 1/2 column toggle */
(function () {
  var toggle = document.querySelector('[data-asc-grid-toggle]');
  var grid = document.querySelector('[data-asc-grid]');
  if (!toggle || !grid) return;
  var KEY = 'ek_grid_cols';
  var saved = localStorage.getItem(KEY) || '1';
  function apply(cols) {
    grid.classList.toggle('grid-2col', cols === '2');
    toggle.querySelectorAll('[data-asc-gt]').forEach(function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-asc-gt') === cols ? 'true' : 'false');
    });
  }
  apply(saved);
  toggle.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-asc-gt]');
    if (!btn) return;
    var cols = btn.getAttribute('data-asc-gt');
    localStorage.setItem(KEY, cols);
    apply(cols);
  });
})();

/* Bottom nav scroll-aware visibility */
(function () {
  var nav = document.querySelector('.asc-bottom-nav');
  if (!nav) return;
  var lastY = window.scrollY || 0;
  var ticking = false;
  function update() {
    var y = window.scrollY || 0;
    if (y < 80) {
      nav.classList.remove('asc-bnav--visible');
    } else if (y < lastY - 4) {
      nav.classList.add('asc-bnav--visible');
    } else if (y > lastY + 8) {
      nav.classList.remove('asc-bnav--visible');
    }
    lastY = y;
    ticking = false;
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
})();
